import { SnapshotResponse } from 'src/modules/statistics/models/snapshotResponse';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'MemberSnapshot';
export const memberSnapshot = (options: SnapshotResponse) => {
  return AxiosInstance.get<PagedResult<SnapshotResponse>>(controller, {
    params: options,
  });
};
